import AScene from "./ExtendedObjects/AScene.js";

export default class Utils
{
    static Initialize(game)
    {
        this.game = game;
    }

    static GetGame()
    {
        return this.game;
    }

    static LogObject(object)
    {
        for (let name of Object.getOwnPropertyNames(Object.getPrototypeOf(object))) {
            let method = object[name];

            console.log(method, name);
        }
    }

    static TransitionScenes(oldScene, newScene_Name, duration, directionY = 1, directionX = 0, ease = "Sinusoidal")
    {
        oldScene.scene.launch(newScene_Name);
        let newChildren = oldScene.game.scene.keys[newScene_Name].children.list;
        let oldChildren = oldScene.children.list;

        oldScene.addDelay(0, ()=>{
            for(let i = 0; i < newChildren.length; i++)
            {
                let child = newChildren[i];
                let oldPos = {x: child.x, y: child.y};
                child.setPosition(child.x + (oldScene.size.width * directionX), child.y + (oldScene.size.height * directionY));
                oldScene.addTween(child, duration, {x: oldPos.x, y: oldPos.y}, ease);
            }
            for(let i = 0; i < oldChildren.length; i++)
            {
                oldScene.addTween(oldChildren[i], duration, {x: oldChildren[i].x - (oldScene.size.width - 2) * directionX, y: oldChildren[i].y - (oldScene.size.height - 2) * directionY}, ease);
            }
            oldScene.addDelay(duration, ()=>{
                oldScene.scene.stop();
            });
        });
    }

    static StagePos(displayObject)
    {
        let curObject = displayObject;
        let pos = {x: curObject.x, y: curObject.y};
        while(curObject.parentContainer != null)
        {
            curObject = curObject.parentContainer;
            pos.x += curObject.x;
            pos.y += curObject.y;
        }

        return pos;
    }

    static RemoveDuplicates(largeArr, toRemove)
    {
        let newArr = [];
        for(let i = 0; i < largeArr.length; i++)
        {
            if(toRemove.indexOf(largeArr[i]) == -1)
            {
                newArr.push(largeArr[i]);
            }
        }
        return newArr;
    }

    /**
     *  @param {AScene} scene 
     */
    static set CurrentScene(scene)
    {
        this.scene = scene;
    }

    static Shuffle(array) 
    { 
        return array.map((a) => [Math.random(),a]).sort((a,b) => a[0]-b[0]).map((a) => a[1]);
    }

    static remove(arr, item) 
    { 
        let index = arr.indexOf(item);
        if(index != -1) arr.splice(index, 1); 
    }

    static copy(arr) 
    { 
        return arr.concat();
    }

    static contains(arr, item) 
    { 
        return (arr.indexOf(item) != -1); 
    }
}
